export const authKeys = {
  profile: ['profile'] as const,
};
